import { customerDiscount } from "constants/customer";

const initialState = {
    customerDiscount: {}
}

const customerDiscountList = (state = initialState, action) => {
    switch (action.type) {
        case customerDiscount:
            return { ...state, customerDiscount: action.payload};
        
        default:
            return state;
    }
};

export default customerDiscountList;